import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IMdbError } from '../../../errorObjects/MdbError';

// export interface IFetchDocumentLinksFailureState {
//   value: IMdbError | null
// }

const initialState: IMdbError | null = null;

export const fetchDocumentLinksFailureSlice = createSlice({
  name: 'fetchDocumentLinksFailure',
  initialState,
  reducers: {
    setFetchDocumentLinksFailure: (state: IMdbError | null, action: PayloadAction<IMdbError>) => {
      state = action.payload;
    },
    clearFetchDocumentLinksFailure: (state: IMdbError | null) => {
      state = null;
    },
  },
})

// Action creators are generated for each function in reducer)
export const { setFetchDocumentLinksFailure, clearFetchDocumentLinksFailure } = fetchDocumentLinksFailureSlice.actions;

// export the core reducer for the slice
export const fetchDocumentLinksFailureReducer = fetchDocumentLinksFailureSlice.reducer;

export default fetchDocumentLinksFailureSlice.reducer;